import React, { useEffect, useState } from 'react';
import { Tilt } from 'react-tilt';
import { motion } from 'framer-motion';
import { zoomIn } from '../../utils/motion';
import ProjectCardContent from './ProjectCardContent.jsx';

const ProjectCard = ({
  index,
  name,
  client,
  position,
  tags,
  image,
  source_code_link,
  live_url,
  client_url,
  isImageLogo,
  onClick,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const projectProps = {
    name,
    client,
    position,
    tags,
    image,
    source_code_link,
    live_url,
    client_url,
    isImageLogo,
  };

  const cardClasses =
    'bg-tertiary rounded-2xl w-full max-w-[360px] min-w-[360px] flex flex-col min-h-[420px] cursor-pointer select-none tap-highlight-transparent';

  return (
    <motion.div
      variants={zoomIn(index * 0.2, 0.6)}
      className="w-full sm:w-auto"
    >
      {isMobile ? (
        <div className={cardClasses} onClick={onClick}>
          <ProjectCardContent {...projectProps} />
        </div>
      ) : (
        <Tilt
          options={{ max: 25, scale: 1, speed: 450 }}
          className={cardClasses}
          onClick={onClick}
        >
          <ProjectCardContent {...projectProps} />
        </Tilt>
      )}
    </motion.div>
  );
};

export default ProjectCard;
